import { MenuItem } from '@mui/material'
import React, { useContext, useRef, useState } from 'react'
import { ArrowRight } from '@mui/icons-material';
import toast from 'react-hot-toast';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { profitLoss } from "../../components/footer/AccountFooter";
import { closeOrderPosition, closeAllPrositionsByHedge, closePositionByHedge, OneClickTrading } from "../../api/request/dashboard/dashboard";
import { deletePositionsData } from "../../store/Slices/orderPositionSlice";
import { ThemeContext } from '../../context/ThemeContext';
import { useTranslation } from 'react-i18next';
import CloseByHedgeModal from '../../components/modal/CloseByHedge';
import EditPositionModal from '../../components/modal/EditSLTP/EditPositionModal';
import ClosePosition from '../../components/modal/trading/ClosePosition';

export default function TradeMenu({ setSubmenuAnchor, handleOpenModifyPositionModal, contextMenu, setContextMenu, style, showColumnsMenu }) {
    const dispatch = useDispatch();
    const { darkMode } = useContext(ThemeContext)
    const [t] = useTranslation()
    const [openEdit, setOpenEdit] = useState(false);
    const [editSLTP, setEditSLTP] = useState([]);
    // const [submenuAnchor, setSubmenuAnchor] = useState(null);
    const positions = useSelector((state) => state.orderPosition.positions, shallowEqual);
    const orderSLTP = useSelector((state) => state.orderPosition.orderSLTP, shallowEqual);
    const { symbols } = useSelector(state => state.watchlist)
    const { accountId } = useSelector(state => state.accountSummary)
    const [selectedPosition, setSelectedPosition] = useState(null);
    const [hedgeModalOpen, setHedgeModalOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const selectedRowsRef = useRef(new Set());
    const [forceUpdate, setForceUpdate] = useState(false);
    const tradeDetail = contextMenu?.row || contextMenu
    const [closeModalOpen, setCloseModalOpen] = useState(false);
    const [selectedCloseTradeId, setSelectedCloseTradeId] = useState(null);
    const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);

    const handleCloseContextMenu = () => {
        // setContextMenu(null);
        setSubmenuAnchor(null);
    };
    const handleEditClick = () => {
        if (!tradeDetail) return;
        const sltpData = orderSLTP.filter((sltp) => sltp.positionId === tradeDetail?.id);

        if (sltpData.length > 0) {
            setEditSLTP(sltpData);
            setOpenEdit(true);

            // handleCloseContextMenu();

        } else {
            toast.error("No S/L, T/P to edit");
        }
    };

    const handleModifyClick = () => {
        if (!tradeDetail) return;

        const positionId = tradeDetail.id;
        const sltpOrdersForPosition = orderSLTP.filter((item) => item.positionId === positionId);

        const positionAmount = tradeDetail.amount || 0;
        const totalManagedAmount = sltpOrdersForPosition.reduce((sum, item) => sum + (item.amount || 0), 0);
        const remainingAmount = Number((positionAmount - totalManagedAmount).toFixed(decimalPlaces));

        if (remainingAmount <= 0) {
            toast.error(`All ${positionAmount} lots are already managed. No remaining volume to modify.`);
        } else {
            const orderDetails = { row: tradeDetail };
            handleOpenModifyPositionModal(orderDetails);
        }

        handleCloseContextMenu();
    };


    const closeUnprofitablePositions = async () => {
        const unprofitableTrades = [...profitLoss]
            .filter(([_, value]) => parseFloat(value) < 0)
            .map(([id, pl]) => {
                const position = positions.find(pos => pos.id === id);

                if (!position) return null;

                return {
                    accountId: accountId,
                    amount: position.amount,
                    positionId: position.id,
                };
            })
            .filter(Boolean);

        if (unprofitableTrades.length === 0) {
            toast.error("No unprofitable positions found!");
            return;
        }
        try {
            const results = await Promise.allSettled(
                unprofitableTrades.map(trade => closeOrderPosition(trade))
            );

            // Extract successfully closed positions
            const successfulTrades = unprofitableTrades.filter((_, index) => results[index].status === "fulfilled");
            if (successfulTrades.length > 0) {
                successfulTrades.forEach(trade => {
                    const position = positions.find(pos => pos.id === trade.positionId);
                    if (position) {
                        toast.success(`Closed Trade #${trade.positionId} (${position.symbolName}) at ${position.side === 1 ? symbols[position.symbolId].bid : symbols[position.symbolId].ask}} ,${position.side === 1 ? "Buy" : 'Sell'}, amount ${position.amount} `);
                    }
                });
            } else {
                toast.error("Failed to close unprofitable positions.");
            }
            // Dispatch delete only for successful closures
            successfulTrades.forEach(trade => dispatch(deletePositionsData(trade.positionId)));


        } catch (error) {
            console.error("Error closing unprofitable positions:", error);
            toast.error("An error occurred while closing positions.", error);
        }
        finally {
            handleCloseContextMenu();
        }

    };
    const closeAllByHedge = async (symbolId, amount) => {
        if (!symbolId) {
            toast.error("Invalid symbol ID.");
            return;
        }

        const filteredTrades = positions
            .filter((item) => item.symbolId === symbolId)
            .map((position) => ({
                firstPositionId: position.id,
                secondPositionId: position.id
            }));

        if (filteredTrades.length === 0) {
            toast.error("No trades to close for this symbol.");
            return;
        }

        const payload = {
            orders: filteredTrades.map((trade) => ({
                accountId,
                amount,
                firstPositionId: trade.firstPositionId,
                secondPositionId: trade.secondPositionId
            })),
        };

        try {
            const response = await closeAllPrositionsByHedge(payload);
            const responses = response?.data?.responses;

            if (!Array.isArray(responses)) {
                toast.error("Unexpected response format.");
                return;
            }

            responses.forEach((res, index) => {
                const order = payload.orders[index];
                const position = positions.find(pos => pos.id === order.firstPositionId);
                const price = position?.side === 1 ? symbols[position.symbolId]?.bid : symbols[position.symbolId]?.ask;
                const side = position?.side === 1 ? "Buy" : "Sell";
                console.log(res?.statusCode);

                if (res?.statusCode == 400) {
                    toast.loading(`Trade is pending: #${order.firstPositionId} (${position?.symbolName}), amount ${position.amount}`);
                }
                if (res.statusCode == 200) {
                    dispatch(deletePositionsData(position));
                    toast.success(`Closed Hedge Trade #${order.firstPositionId} & #${order.secondPositionId} (${position.symbolName}) at ${price}, ${side} amount ${order.amount}`);
                }
                //  else {
                //     toast.error(`Failed to close Trade #${order.firstPositionId}: ${msg}`);
                // }
            });

        } catch (error) {
            console.error("Error closing trades:", error);
            toast.error("Failed to close trades.", error);
        }




        handleCloseContextMenu();
    };
    const closePositionBy_Hedge = async (firstPositionId, secondPositionId, amount) => {
        if (!firstPositionId || !secondPositionId) {
            toast.error("Invalid position IDs.");
            return;
        }

        const payload = {
            accountId: accountId,
            amount: amount,
            firstPositionId,
            secondPositionId
        };

        try {
            const response = await closePositionByHedge(payload);

            const firstPos = positions.find(pos => pos.id === firstPositionId);
            const secondPos = positions.find(pos => pos.id === secondPositionId);

            if (firstPos && symbols[firstPos.symbolId]) {
                toast.success(`Closed Trade #${firstPositionId} (${firstPos.symbolName}) at ${firstPos.side === 1 ? symbols[firstPos.symbolId].bid : symbols[firstPos.symbolId].ask} , ${firstPos.side === 1 ? "Buy" : "Sell"} amount ${firstPos.amount}`);
            }

            if (secondPos && symbols[secondPos.symbolId]) {
                toast.success(`Closed Trade #${secondPositionId} (${secondPos.symbolName}) at ${secondPos.side === 1 ? symbols[secondPos.symbolId].bid : symbols[secondPos.symbolId].ask} , ${secondPos.side === 1 ? "Buy" : "Sell"} amount ${secondPos.amount}`);
            }

            return response.data;
        } catch (error) {
            console.error("Error closing position by hedge:", error);
            toast.error(error);
        }
    };

    const doublePosition = async () => {
        console.log(`double ${JSON.stringify(tradeDetail)}`);

        if (!tradeDetail) {
            toast.error("Invalid trade data.");
            return;
        }

        const { accountId, symbolId, amount, side } = tradeDetail;

        const payload = {
            accountId: accountId,
            side: side,
            amount: amount,
            symbolId: symbolId,
            comment: "Opened by Double Position",
        };

        try {
            const response = await OneClickTrading(payload);
            const newTradeId = response?.id || response?.data?.id;

            if (newTradeId) {
                toast.success(`Opened Trade #${newTradeId} (${tradeDetail.symbolName}) at ${side === 1 ? symbols[symbolId].bid : symbols[symbolId].ask}, ${side === 1 ? "Buy" : "Sell"} amount ${amount}`);
            } else {
                toast.success(`Opened Trade (${tradeDetail.symbolName}) - ID not available`);
            }
        } catch (error) {
            console.error("Failed to double the position:", error);
            toast.error(error);
        }
        finally {
            handleCloseContextMenu();
        }
    };

    const inversePosition = async () => {
        if (!tradeDetail) {
            toast.error("Invalid trade data.");
            return;
        }

        const { accountId, symbolId, amount, side, id } = tradeDetail;

        if (!tradeDetail) {
            toast.error("Invalid trade data.");
            return;
        }

        const inversePayload = {
            accountId: accountId,
            side: side === 1 ? -1 : 1,
            amount: amount,
            symbolId: symbolId,
            comment: `Inverse of trade #${id}`,
        };

        const originalSymbol = symbols[symbolId];
        const price = side === 1 ? originalSymbol?.ask : originalSymbol?.bid;

        try {
            //  Open the inverse position
            await OneClickTrading(inversePayload);
            toast.success(`Inverse Trade #${tradeDetail?.id} (${symbols[tradeDetail?.symbolId]?.name}) at ${tradeDetail?.side === 1 ? symbols[tradeDetail?.symbolId]?.bid : symbols[tradeDetail?.symbolId]?.ask} ${tradeDetail?.side === 1 ? "Buy" : "Sell"} , amount ${tradeDetail.amount}`);
        } catch (error) {
            console.error("Failed to open inverse position:", error);
            toast.error("Failed to open inverse position.");
            handleCloseContextMenu();
            return;
        }

        // Close the original position
        try {
            const closePayload = {
                accountId: Number(accountId),
                positionId: id,
                amount: amount,
            };

            const closeResponse = await closeOrderPosition(closePayload);

            if (closeResponse.status === 200) {
                toast.success(`Closed Trade #${id} (${originalSymbol?.name}) at ${price}, ${side === 1 ? "Buy" : "Sell"}, amount ${amount}`);
            } else {
                toast.error(`Failed to close original trade #${id}`);
            }
        } catch (error) {
            console.error("Failed to close original position:", error);
            toast.error("Error closing the original position.");
        } finally {
            handleCloseContextMenu();
        }
    };

    const closeProfitablePositions = async () => {
        const profitableTrades = [...profitLoss]
            .filter((value) => parseFloat(value[1]) > 0)
            .map(([id, pl]) => {
                const position = positions.find(pos => pos.id === id);

                if (!position) return null;
                return {
                    accountId: accountId,
                    amount: position.amount,
                    positionId: position.id,
                };
            })
            .filter(Boolean);

        if (profitableTrades.length === 0) {
            toast.error("No profitable positions found!");
            return;
        }

        try {
            const results = await Promise.allSettled(
                profitableTrades.map(trade => closeOrderPosition(trade))
            );

            // Extract successfully closed positions
            const successfulTrades = profitableTrades.filter((_, index) => results[index].status === "fulfilled");
            if (successfulTrades.length > 0) {
                successfulTrades.forEach(trade => {
                    const position = positions.find(pos => pos.id === trade.positionId);
                    if (position) {
                        toast.success(`Closed Trade #${trade.positionId} (${position.symbolName}) at ${position.side === 1 ? symbols[position.symbolId].bid : symbols[position.symbolId].ask}} ,${position.side === 1 ? "Buy" : 'Sell'} amount ${position.amount} `);
                    }
                });

            } else {
                toast.error("Failed to close profitable positions.");
            }
            // Dispatch delete only for successful closures
            successfulTrades.forEach(trade => dispatch(deletePositionsData(trade.positionId)));


        } catch (error) {
            console.error("Error closing profitable positions:", error);
            toast.error(error);
        } finally {
            handleCloseContextMenu();
        }
    };
    const handleCloseByHedgeClick = () => {

        if (!tradeDetail?.id) {
            toast.error("Invalid position.");
            return;
        }

        const oppositePosition = positions.find((pos) => pos.symbolId === tradeDetail?.symbolId && pos.side !== tradeDetail?.side);

        if (oppositePosition) {
            const { bid, ask, bidColor, askColor, digits } = symbols[tradeDetail?.symbolId] || {};

            if (bid !== undefined && ask !== undefined) {
                setSelectedPosition({ ...tradeDetail, bid, ask, bidColor, askColor, digits });
                setHedgeModalOpen(true);
                handleCloseContextMenu();
            } else {
                toast.error("Bid and ask prices not available.");
            }
        } else {
            toast.error("No opposite positions available for hedge.");
        }
    };
    const handleCloseClick = async (rowIndex = null, orderId = null, customAmount = null) => {
        const ordersToClose = orderId ? [orderId] : rowIndex !== null ? [positions[rowIndex]?.id] : selectedRows;

        if (ordersToClose.length === 0) {
            toast.error("No trades selected");
            return;
        }

        const closeRequests = ordersToClose.map(async (orderId) => {
            const selectedRow = positions.find(row => row.id === orderId);
            if (!selectedRow) return { success: false, positionId: orderId };

            const closeOrderPayload = {
                accountId: Number(accountId),
                positionId: selectedRow.id,
                amount: customAmount ?? selectedRow.amount,
            };

            try {
                const response = await closeOrderPosition(closeOrderPayload);
                if (response.status === 200) {
                    // dispatch(deletePositionsData(orderId));
                    return { success: true, positionId: orderId, position: selectedRow, message: response?.data?.message || "Unexpected error" };
                }
            } catch (error) {
                const apiMessage = error?.response?.data?.message || error?.message || "Unknown error";
                console.error("Error closing order:", error);
                return { success: false, positionId: orderId, position: selectedRow, message: apiMessage, };
            }
            return { success: false, positionId: orderId, position: selectedRow };
        });

        const results = await Promise.allSettled(closeRequests);

        results.forEach(({ status, value }) => {
            if (status === "fulfilled" && value?.success) {
                const { positionId, position } = value;
                if (position) {
                    const { symbolId, symbolName, side, profitLoss } = position;
                    const price = side === 1 ? symbols[symbolId]?.bid : symbols[symbolId]?.ask;
                    const tradeSide = side === 1 ? "Buy" : "Sell";

                    toast.success(`Closed Trade #${positionId} (${symbolName}) at ${price}, ${tradeSide} , amount ${position.amount}, P/L ${profitLoss}`);
                }
            } else {
                const { positionId, position,message } = value;
                if (position) {
                    const { symbolId, symbolName, side } = position;
                    const price = side === 1 ? symbols[symbolId]?.bid : symbols[symbolId]?.ask;

                    toast.error(` Failed to close Trade #${positionId} (${symbolName}) at ${price} due to: ${message || "unknown error"}`);
                }
            }
        });

        setSelectedRows([]);
        selectedRowsRef.current = [];
        setForceUpdate(prev => !prev);
        handleCloseContextMenu();
    };
    const handleConfirmClose = async (amount) => {
        await handleCloseClick(null, selectedCloseTradeId, amount);
        setCloseModalOpen(false);
    };

    const handleClosePositionMenuClick = () => {
        if (tradeDetail) {
            setSelectedPosition(tradeDetail);
            setSelectedCloseTradeId(tradeDetail?.id);
            setCloseModalOpen(true);
        } else {
            toast.error("No trade selected to close.");
        }
    };

    const closeModal_CloseByHedgeModal = () => {
        setHedgeModalOpen(false);
        setContextMenu(null);
    }
    const closeModal_ClosePosition = () => {
        setCloseModalOpen(false);
        setContextMenu(null);
    }
    const closeModal_EditPosition = () => {
        setOpenEdit(false);
        setContextMenu(null);
    }
    return (
        <>
            <div style={{ backgroundColor: darkMode ? "#262f3f" : "" }}>
                {/* <MenuItem sx={style} onClick={() => { setContextMenu(null); handleChartFromTradeTabClick(symbols[tradeDetail.symbolId]) }}>{t('chart')}</MenuItem> */}
                <MenuItem sx={style} onClick={handleEditClick}>{t('editposition')}</MenuItem>
                <MenuItem sx={style} onClick={() => { setContextMenu(null); handleModifyClick(); }}>{t('modifyPosition')}</MenuItem>
                <MenuItem sx={style} onClick={() => { setContextMenu(null); inversePosition(); }}>{t('inversePosition')}</MenuItem>
                <MenuItem sx={style} onClick={() => { setContextMenu(null); doublePosition(); }}>{t('doublePosition')}</MenuItem>
                <MenuItem sx={style} onClick={handleClosePositionMenuClick}>{t("ClosePosition")} ({tradeDetail?.symbolName})</MenuItem>
                <MenuItem sx={style} onClick={() => { handleCloseByHedgeClick(); }}>{t("closeByHedge")}</MenuItem>
                <MenuItem sx={style} onClick={() => { setContextMenu(null); closeAllByHedge(tradeDetail?.symbolId, tradeDetail?.amount) }}>{t('closeAllByHedge')} ({tradeDetail?.symbolName})</MenuItem>
                <MenuItem sx={style} onClick={() => { setContextMenu(null); closeProfitablePositions(); }}>{t('closeProfitablePosition')}</MenuItem>
                <MenuItem sx={style} onClick={() => { setContextMenu(null); closeUnprofitablePositions(); }}>{t('closeUnrofitablePosition')}</MenuItem>
                {showColumnsMenu && <MenuItem onClick={(e) => { setContextMenu(null); setSubmenuAnchor(e.currentTarget) }} sx={style}>{t('columns')} <ArrowRight /></MenuItem>}
            </div>

            {hedgeModalOpen && (<CloseByHedgeModal open={hedgeModalOpen} onClose={closeModal_CloseByHedgeModal} selectedPosition={selectedPosition} closePositionBy_Hedge={closePositionBy_Hedge} />)}
            {openEdit && (<EditPositionModal open={openEdit} handleClose={closeModal_EditPosition} editSLTP={editSLTP} />)}
            {closeModalOpen && (<ClosePosition open={closeModalOpen} onClose={closeModal_ClosePosition} selectedPosition={selectedPosition} onConfirm={handleConfirmClose} />)}
        </>
    )
}
